export const contentMappingTransfer = {
    speedy_shuttle: {
        heading: 'Speedy Shuttle',
        description:
            'Transfer im Bus-Shuttle vom Flughafen zu Ihrem Hotel und zurück. Die Wartedauer am Flughafen beträgt maximal 45 Minuten und es werden höchstens sechs Hotels angefahren.',
        short_description: 'Bus Transfer ab Flughafen',
    },
    shuttle: {
        heading: 'Shuttle',
        description:
            'Transfer im Bus-Shuttle vom Flughafen zu Ihrem Hotel und zurück. Die Wartedauer am Flughafen kann bis zu 70 Minuten betragen, die Fahrtzeit ist von der Anzahl der angefahrenen Hotels abhängig (maximal 15 Stopps).',
        short_description: 'Shuttle Transfer ab Flughafen',
    },
    taxi: {
        heading: 'Privattransfer',
        description:
            'Privattransfer vom Flughafen zu Ihrem Hotel und zurück. Sie werden von Ihrem Fahrer abgeholt und gelangen bequem ohne Zwischenhalte an Ihr Ziel.',
        short_description: 'Privattransfer ab Flughafen',
    },
};
export default contentMappingTransfer;
